import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { FixedContainer } from '@calendly/ui/components/fixed-container';
import classNames from 'classnames';
import { forwardRef, useMemo } from 'react';
import { useIntercomPosition } from 'components/external/intercom_chat_bot/useIntercomPosition';
import { useAiChatDiscoveryFabVisibility } from './ai_chat_discovery_fab_visibility';
import { AI_CHAT_DISCOVERY_FAB_APPEARANCE } from './constants';
const fabBaseCss = "f16fo6nl";
const ButtonFixedContainer = forwardRef(({
  className,
  rightOffsetPx,
  ...rest
}, ref) => <FixedContainer ref={ref} {...rest} style={{
  right: `${rightOffsetPx}px`
}} className={classNames(fabBaseCss, className)} data-ai-discovery-fab-right-offset={rightOffsetPx} />);
const INTERCOM_BUTTON_WIDTH = 48;
const FLOATING_FAB_HORIZONTAL_GAP_PX = 8;
export const AiChatDiscoveryFloatingButton = () => {
  // TODO: in SA-3840 try to merge these two hooks
  const {
    showFab,
    fabAppearance,
    openOrReplace,
    close,
    paneName
  } = useAiChatDiscoveryFabVisibility();
  const {
    horizontalPadding,
    isPhone
  } = useIntercomPosition();
  const rightOffsetPx = useMemo(() => isPhone ? 24 : horizontalPadding + INTERCOM_BUTTON_WIDTH + FLOATING_FAB_HORIZONTAL_GAP_PX, [horizontalPadding, isPhone]);
  if (!showFab) {
    return null;
  }
  const toggleAiChatRail = () => {
    if (paneName === 'ai_chat') {
      close();
    } else {
      openOrReplace('ai_chat');
    }
  };
  const stringLabel = I18n.t('publisher.agent_hub.discovery_fab.string_label');
  const iconAriaLabel = I18n.t('publisher.agent_hub.discovery_fab.icon_aria_temp');
  if (fabAppearance === AI_CHAT_DISCOVERY_FAB_APPEARANCE.ICON) {
    return <ButtonFixedContainer rightOffsetPx={rightOffsetPx}>
        <Button decoration="ai" onClick={toggleAiChatRail} aria-label={iconAriaLabel} data-calendly-label="ai-chat-discovery-fab-icon" data-testid="ai-chat-discovery-fab-icon" />
      </ButtonFixedContainer>;
  }
  if (fabAppearance === AI_CHAT_DISCOVERY_FAB_APPEARANCE.STRING) {
    return <ButtonFixedContainer rightOffsetPx={rightOffsetPx}>
        <Button decoration="ai" onClick={toggleAiChatRail} data-calendly-label="ai-chat-discovery-fab-string" data-testid="ai-chat-discovery-fab-string">
          {stringLabel}
        </Button>
      </ButtonFixedContainer>;
  }
  return null;
};

require("./AiChatDiscoveryFloatingButton.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AiChatDiscoveryFloatingButton.js");